import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  price: FelaCSS;
  description: FelaCSS;
}

const styles = (): IStyles => ({
  price: {
    fontDefaultSemiBold: 20,
    lineHeight: '150%',
    paddingBottom: 6,
  },
  description: {
    fontDefault: 16,
    lineHeight: '150%',
    color: colors.space60,
    paddingBottom: 6,
    wordBreak: 'break-word',
  },
});

export default styles;
